/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./usdEvent.vue?vue&type=template&id=1a4068eb&scoped=true"
import script from "./usdEvent.vue?vue&type=script&lang=js"
export * from "./usdEvent.vue?vue&type=script&lang=js"
import style0 from "./usdEvent.vue?vue&type=style&index=0&id=1a4068eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4068eb",
  null
  
)

export default component.exports